// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import instance from './axios/request'
import less from 'less'
import Vant, { Toast, Dialog, Notify } from 'vant'
import VueI18n from 'vue-i18n'
import md5 from 'md5'
import * as echarts from 'echarts'

import 'vant/lib/index.css'
import 'reset.less'
// import '!less-loader!./assets/css/main.less'
// import './assets/css/base.css'
// import './assets/icon/iconfont.css'

import MemberLayout from './views/layout/member'
import TopbarLayout from './views/layout/topbar'
import BlankLayout from './views/layout/blank'

Vue.prototype.$echarts = echarts
// import Cookies from 'js-cookie'

Vue.component('member-layout', MemberLayout)
Vue.component('topbar-layout', TopbarLayout)
Vue.component('blank-layout', BlankLayout)

Vue.config.productionTip = false
Vue.prototype.$http = instance
Vue.prototype.$md5 = md5

Vue.use(VueI18n)
Vue.use(less)
Vue.use(Vant)
Vue.use(Toast)
Vue.use(Notify)
Toast.setDefaultOptions({ overlay: true })
Vue.use(Dialog)
Dialog.setDefaultOptions({
  confirmButtonText: '确认按钮文案',
  cancelButtonText: '取消按钮文案'
})
const i18n = new VueI18n({
  locale: 'Es',
  // 语言标识
  // this.$i18n.locale
  // 通过切换locale的值来实现语言切换
  messages: {
    // 'Brazil': require('./lang/Brazil.js'), // 英文语言包
    // 'En': require('./lang/En.js') // 英文语言包
    'Es': require('./lang/Es.js') // 西班牙语言包
    // 'Idn': require('./lang/Idn.js') // 印尼语言包
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})

// router变更改变 Title
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  console.log('router:', to.name, from.name)
  // if (to.meta.title) {
  //   let t = i18n.t(to.meta.title)
  //   document.title = t
  // }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js